<div class="product-stock" [ngClass]="{ 'no-stock': !has }">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8.00004" cy="7.99967" r="4.66667" fill="currentColor" />
  </svg>

  @if (labelable) {
    @if (has) {
      {{ 'product.haveStock' | translate }}
    } @else {
      {{ 'product.noStock' | translate }}
    }
  }
</div>
